export class K2SocleAllActiveTasks{ 
    "serialNumber": string
    "status": string
    "folio": string
    "locatedUser": string
    "workflowName": string
    "worklistItemId": string
    "processStartDate": string
    "activityName": string
    "procInstID": string
}[]



export class K2Api{
    "requestId": string
    "requestor": {
      "user": string
      "displayName": string
    }
    "comment": string
    "requestType": {
      "id": string
      "labelEn": string
      "labelFr": string
      "fieldValueFinal": string
      "fieldValueFinalFr": string
      "approver1": string
      "approver2": string
      "approver3": string
      "approver4": string
      "approver5": string
      "approver6": string
    }
    "creationDate": string
    "supplierName": string
    "allianceId": string
    "supplierDetail": string
    "status": string
    "serialNo": string
    "folio": string
    "folioFr": string
    "procInstid": string
    "validatorRole": string
    "vsupplierIPN": string
    "vsupplierName": string
    "vbuyerIPN": string
    "vbuyerName": string
    "vbuyerAssistantIPN": string
    "vbuyerAssistantName": string
    "vfinalIPN": string
    "vfinalName": string
    "vadminIPN": string
    "vadminName": string
    "vsupplyAdminIPN": string
    "vsupplyAdminName":string
    "vBisAdmin1IPN": string
    "vBisAdmin1Name":string
    "vOtherAdmin1IPN": string
    "vOtherAdmin1Name": string
    "vOtherAdmin2IPN": string
    "vOtherAdmin2Name": string
    "vOtherAdmin3IPN": string
    "vOtherAdmin3Name": string
    "vManagerIPN": string
    "vManagerName": string
    "lastModificationDate": string
    "lastComment": string
    "currentValidtor": string
    "strRequestType": string
  }  
  export class K2Apis{    
      "listRequestDetails": K2Api[]
  }